import { IssueSubmissionResult } from '../ReportIssue/types'
import { HeaderType } from './types'

export const getHeaderType = (result: string): HeaderType => {
  switch (result) {
    case IssueSubmissionResult.SUCCESS:
      return HeaderType.SUCCESS
    case IssueSubmissionResult.ALREADY_SUBMITTED:
      return HeaderType.WARNING
    default:
      return HeaderType.SUCCESS
  }
}

export const getHeaderContent = (result: string, taskCreated?: boolean) => {
  switch (result) {
    case IssueSubmissionResult.SUCCESS:
      return {
        headerText: 'Issue Submitted!',
        headerBodyText: taskCreated
          ? 'Our support team will text you as soon as possible — please keep your phone nearby.'
          : `You'll hear back from us within 24 hours.`,
      }
    case IssueSubmissionResult.ALREADY_SUBMITTED:
      return {
        headerText: 'Issue Already Submitted',
        headerBodyText: 'You have an open support ticket. Check your email for updates from our team.',
      }
    default:
      return {
        headerText: 'Issue Submitted!',
        headerBodyText: `You'll hear back from us within 24 hours.`,
      }
  }
}
